/// <reference path="pages.js"/>

function RequestPasswordForDecryption(Doc, OnPasswordEnter, OnClose, SetNewPassword, ChangePassword) {
  var settings = {
    ok: function () {
      var password = $("#docPassword").val();
      $("#docPassword").data('entered', true);
      if (!!SetNewPassword && OnPasswordEnter) {
        var passwordConfirm = $('#docPasswordConfirm').val();
        return OnPasswordEnter(password, passwordConfirm);
      }
      if (!!ChangePassword && OnPasswordEnter) {
        var oldPassword = $('#docOldPassword').val();
        var passwordConfirm = $('#docPasswordConfirm').val();
        return OnPasswordEnter(oldPassword, password, passwordConfirm);
      }
      if (OnPasswordEnter) return OnPasswordEnter(password);
    }
  };
  var dialog = new WA.components.dialogs.BaseDialog(settings);

  var docName = '<div id="requestDocPasswordForm">';
    //'<div><div id="requestDocPasswordFormIcon">' +
    //'<img src="' + Doc.Editor.Icon32Url + '"></img></div><div>' + Doc.ClientName + '.' + Doc.Editor.Extension.toLowerCase() + '</div>' +
    //'</div>';
  var passwordInput = '<div id="requestDocPasswordFormPass"><table>' +
    (!!ChangePassword ? '<tr><td><div><label>*' + L('OLD_PASSWORD') + ': </label></td><td><input type="password" id="docOldPassword" class="input" onkeyup="OnKeyUpPassDoc(event, this,' + dialog.id + ');" /></td></tr>' : '') +
    '<tr><td><label>*' + L('PASSWORD') + ': </label></td><td><input type="password" id="docPassword" class="input" onkeyup="OnKeyUpPassDoc(event, this,'+ dialog.id +');" /></td></tr>' +
    (!!SetNewPassword || !!ChangePassword ? '<tr><td><label>*' + L('CONFIRMATION') + ': </label></td><td><input type="password" class="input" id="docPasswordConfirm" onkeyup="OnKeyUpPassDoc(event, this,' + dialog.id + ');" /></td></tr>' : '') +
    '</table></div></div>';


  dialog.title = L("ENTER_PASSWORD");
  dialog.isShowCancelButton = true;
  //dialog.onClose = function () { clearAllModalDivs(); }
  if (!!OnClose) dialog.onClose = function() { OnClose(); };
  dialog.onOpen = function () { BindPasswordFieldToOk(dialog); dialog.disableButton('modal_ok_button'); };
  dialog.setHtml(docName + passwordInput);
  dialog.show();
  return dialog;
}

function OnKeyUpPassDoc(event, el, id) {
  if (event.keyCode == 13) {
    event.preventDefault();
    event.stopPropagation();
    var button = $('#dialog_content_' + id).parent().parent().find('button.primary'); //$('div.ui-dialog').find('.ui-dialog-buttonset:visible').children().first();
    if (!button.hasClass('disabled')) button.click();
    return false;
  }
}

function BindPasswordFieldToOk(dialog) {
  $('#docPassword').keyup(function (ev) {
    if ($(this).val() != '')
    {
      dialog.enableButton('modal_ok_button');
    }
    else {
      dialog.disableButton('modal_ok_button');
    }
  });
}


function SetPasswordForDoc(checkbox) {
  checkbox = $(checkbox);
  if (checkbox.is(':checked')) {
    if (true){//$('#__SELECTED_USERS').val().indexOf('g_') == -1) {
      if (!!checkbox.data('password')) {
      }
      else {
        if (WA.Document.Encoding < 2) {
          RequestPasswordForDecryption("", function (password, confirmation) {
            if (!IsPasswordConfirmed(password, confirmation)) return false;
            checkbox.data('password', password);
            return true;
          },
          function () {
            if (!!!checkbox.data('password') && checkbox.data('password') != "") { checkbox.removeAttr('checked'); }
          },
          true);
        }
      }
    }
    else {
      ShowWarning(L('CANNOT_ENCRYPT_PASSWORD_USERGROUP_QUALIFIED'), null, 400);
      checkbox.removeAttr('checked');
    }
  }
  else {
    if (WA.Document.Encoding >= 2) {
      RequestPasswordForDecryption("", function (password) {
        checkbox.data('password', password);
        //WA.current.toolBar.buttons.ChangeDocPassword.disable();
      },
      function () {
        if (!!!checkbox.data('password')) { checkbox.attr('checked', true); }
      });
    }
    else {
      checkbox.data('password', null);
    }
  }
}

function ChangeDocPassword() {

  var changePassword = function (oldPassword, password, encryptionKey) {
    encryptionKey = !!encryptionKey ? encryptionKey : "";
    WA.SRV.call("/Document.asmx/ChangePassword", { DocumentID: WA.Document.ID, OldPassword: oldPassword, NewPassword: password, EncryptionKey : encryptionKey }).success(function () {
      HideTopSpinner(L("USER_PASSWORD_WAS_CHANGED_SUCCESSFULLY"), 2000);
    }).fail(function (error) {
      ShowError(error);
    });
  };

  if (WA.Document.Encoding >= 2)
  {
    RequestPasswordForDecryption("", function (oldPassword, password, confirmation) {
      if (!IsPasswordConfirmed(password, confirmation)) return false;

      if (WA.Document.Encoding == 3) {
        RequestToken(TOKEN_OPERATION.DOWNLOAD_DOCUMENT_BODY, function (token) {
          WebAccess.agent.transmitRequest("getdocdecryptedkey", "edmsplugin",
            { "DocID": WA.Document.ID, "Version": 0, "Token": token, "EncodeType": WA.Document.Encoding, "EncryptionPluginName": WA.Document.PluginName, "Password": oldPassword })
            .done(function(response) {
                changePassword(oldPassword, password, response.result);
            }).fail(function(response) {
              ShowError(response.message);
            });
        }, WA.Document.ID, 0);
        return true;
      }
      changePassword(oldPassword, password, null);
      return true;
    }, null, null, true);
  }
}

function IsPasswordConfirmed(password, confirmation)
{
  if (password != "" && confirmation == "") {
    ShowWarning(L("WRN_ENTER_PASSWORD_CONFIRAMATION"), null, 350, function () { $('#docPasswordConfirm').focus(); });
    return false;
  }
  if (password != confirmation) {
    ShowWarning(L("WRN_PASSWORD_AND_CONFIRMATION_MUST_MATCH"), null, 350, function () { $('#docPasswordConfirm').focus(); });
    return false;
  }
  if (password == "") return false;
  return true;
}

function SetCertForDoc(checkbox) {
  checkbox = $(checkbox);
  var passwordCheckbox = $('#EncryptWithPasswordCheckBox');
  if (checkbox.is(':checked')) {
    if (true){//$('#__SELECTED_USERS').val().indexOf('g_') == -1) {
      if (WA.Document.Encoding == 3) {
        passwordCheckbox.data('password', null);
      }
      if (WA.Document.Encoding == 2) {
        RequestPasswordForDecryption("", function (password) {
          passwordCheckbox.data('password', password);
          return true;
        },
        function () {
          if (!!!passwordCheckbox.data('password') && checkbox.data('password') != "") { checkbox.removeAttr('checked'); }
        });
      }
    }
    else {
      ShowWarning(L('CANNOT_ENCRYPT_CERT_USERGROUP_QUALIFIED'), null, 400);
      checkbox.removeAttr('checked');
    }
  }
  else {
    if (WA.Document.Encoding == 3) {
      if (!passwordCheckbox.data('password') || passwordCheckbox.data('password') == "") {
        RequestPasswordForDecryption("", function (password) {
          passwordCheckbox.data('password', password);
          //WA.current.toolBar.buttons.ChangeDocPassword.disable();
          return true;
        },
        function () {
          if (!passwordCheckbox.data('password') && passwordCheckbox.data('password') != "") { checkbox.attr('checked', true); }
        });
      }
    }
  }
}
